
define(
	'C3.ShoppingExtensions.ViewInventory'
,   [
		'C3.ShoppingExtensions.ViewInventory.View',
		'C3.ShoppingExtensions.ViewInventory.Router'
	]
,   function (
		ViewInventoryView,
		Router
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			var layout = container.getComponent('Layout');
			var pageType = container.getComponent('PageType');
			var environment = container.getComponent("Environment");
			
			if(layout)
			{
				 return new Router(container);
			}

		}
	};
});
